// libs
import React, { useState, memo } from 'react';

// global components
import Loader from 'shared/components/Loader';

// helpers
import { generateSameHostUrl } from 'shared/helpers/utils';

// styles
import { Modal, Iframe, innerClassName, iFrameStyles } from './styles';

//defs
export interface IFrameModalProps {
  sizeGuideURL: string;
  onRemove: VoidFunction;
}

const SizeChartOverlay = ({ sizeGuideURL, onRemove }: IFrameModalProps) => {
  const [loading, setLoading] = useState(true);

  const onLoadComplete = (event: React.SyntheticEvent<HTMLIFrameElement, Event>): void => {
    const ifrm = event.currentTarget;
    // reference to document in iframe
    // @ts-ignore
    const doc = ifrm.contentDocument ? ifrm.contentDocument : ifrm.contentWindow.document;

    const cssElement: HTMLStyleElement = document.createElement('style');

    cssElement.type = 'text/css';

    // @ts-ignore
    if (cssElement.styleSheet !== undefined) {
      //Code specific for IE
      // @ts-ignore
      cssElement.styleSheet.cssText = iFrameStyles;
    } else {
      //Code specific for all other browsers
      cssElement.appendChild(document.createTextNode(iFrameStyles));
    }

    doc.head.appendChild(cssElement);
    setLoading(false);
  };

  return (
    <Modal innerClassName={innerClassName} onHide={onRemove} dataAtValue="size-modal-close">
      {loading && <Loader />}
      <Iframe
        src={generateSameHostUrl(sizeGuideURL)}
        title="Size Chart"
        data-test="size-chart-iframe"
        onLoad={onLoadComplete}
      />
    </Modal>
  );
};

export default memo(SizeChartOverlay);
